import {Component, Input} from '@angular/core';
import {Router} from '@angular/router';
import {DividerModule} from 'primeng/divider';
import {InputComponent} from '../../../../components/form/input/input.component';
import {MenuInterface} from '../../../../components/menu/menu-interface';
import {Routing} from '../../../../models/routing/routing';
import {windowOpen} from '../../../../utils/window-utils';
import {ActionButtonComponent} from '../../../../components/form/action-buttons/action-button.component';

@Component({
    selector: 'app-an-invoices-menu',
    imports: [DividerModule, InputComponent, ActionButtonComponent],
    templateUrl: './an-invoices-menu.component.html'
})
export class AnInvoicesMenuComponent implements MenuInterface {
    @Input() data: any;
    whsid = '';

    constructor(private router: Router) {
    }

    searchByWhsid() {
        if (!this.whsid || !this.whsid.trim()) {
            return;
        }

        windowOpen(Routing.anInvoices.byWhsid(encodeURIComponent(this.whsid.trim())), '_blank');
        this.whsid = '';
    }

    protected toToInvoices() {
        windowOpen(Routing.anInvoices.list(), '_blank');
    }
}
